import { Gift, Trash2 } from "lucide-react";

export const PERK_TYPES = [
  { v: "fixed_price", label: "Fixed price" },
  { v: "percent_off", label: "Percent off" },
  { v: "amount_off", label: "Amount off" },
];

export function perkSummary(perk) {
  if (!perk || !perk.active) return null;
  if (perk.type === "fixed_price") return `₹${perk.value}`;
  if (perk.type === "percent_off") return `${perk.value}% off`;
  if (perk.type === "amount_off") return `₹${perk.value} off`;
  return null;
}

const label = "mb-1 block text-[10px] font-bold uppercase tracking-wide text-zinc-500";
const field = "w-full rounded border border-zinc-700 bg-zinc-950 px-2 py-1.5 text-sm text-white outline-none focus:border-[#A855F7]";

export default function PerkFields({ perk, onChange, idPrefix = "perk" }) {
  if (!perk) {
    return (
      <button
        type="button"
        data-testid={`${idPrefix}-add`}
        onClick={() => onChange({ type: "fixed_price", value: 0, currency: "INR", label: "", expires_at: null, max_redemptions: null, active: true })}
        className="inline-flex items-center gap-1.5 rounded-lg border border-[#A855F7]/40 bg-[#A855F7]/10 px-3 py-1.5 text-xs font-bold text-[#A855F7] hover:bg-[#A855F7]/20"
      >
        <Gift className="h-3.5 w-3.5" /> Add a perk / discount
      </button>
    );
  }
  const set = (k, v) => onChange({ ...perk, [k]: v });
  const valLabel = perk.type === "percent_off" ? "% off" : perk.type === "amount_off" ? "₹ off" : "₹ price";
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      <div>
        <label className={label}>Discount type</label>
        <select data-testid={`${idPrefix}-type`} className={field} value={perk.type} onChange={(e) => set("type", e.target.value)}>
          {PERK_TYPES.map((t) => <option key={t.v} value={t.v}>{t.label}</option>)}
        </select>
      </div>
      <div>
        <label className={label}>Value ({valLabel})</label>
        <input type="number" min={0} data-testid={`${idPrefix}-value`} className={field} value={perk.value} onChange={(e) => set("value", Number(e.target.value))} />
      </div>
      <div>
        <label className={label}>Label (optional)</label>
        <input data-testid={`${idPrefix}-label`} className={field} value={perk.label || ""} onChange={(e) => set("label", e.target.value)} placeholder="e.g. Launch offer" />
      </div>
      <div>
        <label className={label}>Expires (optional)</label>
        <input type="date" data-testid={`${idPrefix}-expiry`} className={field} value={(perk.expires_at || "").slice(0, 10)} onChange={(e) => set("expires_at", e.target.value ? `${e.target.value}T23:59:59Z` : null)} />
      </div>
      <div>
        <label className={label}>Max redemptions (optional)</label>
        <input type="number" min={0} data-testid={`${idPrefix}-max`} className={field} value={perk.max_redemptions ?? ""} onChange={(e) => set("max_redemptions", e.target.value === "" ? null : Number(e.target.value))} />
      </div>
      <div className="flex items-end justify-between gap-2">
        <label className="inline-flex items-center gap-2 text-xs text-zinc-300">
          <input type="checkbox" className="h-4 w-4 accent-[#A855F7]" checked={!!perk.active} onChange={(e) => set("active", e.target.checked)} data-testid={`${idPrefix}-active`} /> Active
        </label>
        <button type="button" onClick={() => onChange(null)} data-testid={`${idPrefix}-remove`} className="inline-flex items-center gap-1 rounded border border-rose-500/40 px-2 py-1 text-xs text-rose-300 hover:bg-rose-500/10">
          <Trash2 className="h-3 w-3" /> Remove
        </button>
      </div>
    </div>
  );
}
